var checkbox_products_set = false;
var remove_product_text = 'Remove';
var added_product_text = 'Added';
var add_to_cart_text = 'Add to Cart';
var max_options = 1; //show how many options we need to show

var featured_products = [];
featured_products.push('sunflower-bee-ring');
featured_products.push('more-kindness-sweatshirt');


var bundle_products = [];
// bundle_products.push('aumua-triangular-powder-puff-6pcs');
// bundle_products.push('aumua-round-nice-led-makeup-bag'); 

var checkbox_products = [];
// checkbox_products.push('42851665576127');
// checkbox_products.push('42851665608895'); 


var auto_add_checkbox_products = false; //if need to auto add these products
var  auto_add_product = [];
// auto_add_product.push('42851665576127');
// auto_add_product.push('42851665608895'); 

function updateCartDrawer(need_toggleDrawer = 0, overlay_show=1) {

  if(overlay_show==1)
  $('#crm_overlay').show();

  var cart_variants = [];
  var cart_handles = [];


  $.ajax({
    url: '/cart.json',
    dataType: 'json',
    success: function (cart) {
      // Empty the current contents of the cart drawer
      $('.crm_drawer_cart_inner1').html('');
      var cartItemHtml = '';
      // Loop through each item in the cart
      $.each(cart.items, function (index, item) {
        cart_variants.push(String(item.variant_id));
        cart_handles.push(item.handle);
        var in_cart = checkbox_products.indexOf(item.variant_id + '');
        if (in_cart == -1) {
          cartItemHtml += `
              <div class="cart__item" data-key="${item.key}">
                <div class="cart__image">
                  <a href="${item.url}" class="image-wrap">
                    <img src="${item.image}" alt="${item.product_title}" loading="lazy" class="image-element" style="width:100px">
                  </a>
                </div>
                <div class="cart__item-details">
                  <div class="cart__item-title"> 
                     <b>${item.product_title}</b>`;
          
                    item.options_with_values.forEach(function (option) {
            cartItemHtml += `<div class="cart__item--variants"><div><span>${option.name}:</span> ${option.value}</div></div>`;
          });

           
          
           
          original_line_price = fetch_compare_at_price(item.handle, item.variant_id) * item.quantity;

          cartItemHtml += `</div><div class="cart__item-sub">
                    <div class="js-qty__wrapper">
                    <input type="text"  id="qty_${item.variant_id}" class="js-qty__num" value="${item.quantity}" min="0" pattern="[0-9]*"  >
                    <button type="button" onclick="crm_update_qty('${item.variant_id}','-1')" class="js-qty__adjust js-qty__adjust--minus" aria-label="Reduce item quantity by one">
                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path></svg>
                        <!-- <span class="icon__fallback-text" aria-hidden="true">−</span> -->
                    </button>
                    <button type="button" onclick="crm_update_qty('${item.variant_id}','+1')" class="js-qty__adjust js-qty__adjust--plus" aria-label="Increase item quantity by one">
                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg>
                        <!-- <span class="icon__fallback-text" aria-hidden="true">+</span> -->
                    </button>
                    </div>
                    <div class="cart__item-price-col text-right">`;

                    if(original_line_price>(item.discounted_price * item.quantity))
                        cartItemHtml +=  `<span class="cart__price line-through">$${original_line_price / 100}</span><Br/>`;


                      cartItemHtml += `<span class="cart__price"><b>$${(item.discounted_price * item.quantity) / 100}</b></span>
                    </div>
                  </div>
                </div>
              </div>
            `;
        }
      });




      if (cartItemHtml == '') {
        cartItemHtml = '<i style="color:#c9c9c9;">Your cart is currently empty.</i>';
        $('.crm_drawer_cart_inner4').html('');
        $('.cart-link__bubble').removeClass('cart-link__bubble--visible');
        $('.cart-count-bubble').remove();
        // $('.crm_drawer_cart_inner3').hide();

      } else {
        $('.cart-link__bubble').addClass('cart-link__bubble--visible');
        $('.crm_drawer_cart_inner3').show();
        $('.crm_drawer_cart_inner4').html('<span>Shipping, taxes, and discount codes calculated at checkout.</span><Br/>');
        $('<button/>', {
          text: 'Proceed Checkout',
          class: 'button btn-100',
          id: 'cart__checkout_btn',
          click: function () {
            window.location.href = '/pages/checkout-4';
          }
        }).insertAfter('.crm_drawer_cart_inner4 span');
        $('#cart-icon-bubble').append(`<div class="cart-count-bubble"><span aria-hidden="true">${cart.item_count}</span><span class="visually-hidden">${cart.item_count} items</span>
        </div>`);
      }
      $('.crm_drawer_cart_inner1').html(cartItemHtml);
      // Update the subtotal and item count
      $('.crm_drawer_cart_inner1').attr('data-count', cart.item_count);
      $('.crm_drawer_cart_inner1').attr('data-cart-subtotal', cart.total_price);
      $('.crm_sub_total').html(cart.currency + ' ' + cart.total_price / 100);

      if ($('#is_checkout_page').val() == 1) 
      {
        $('.cart-subtotal').find('span').html(cart.currency + ' ' + cart.total_price / 100);        
      }
      var checkbox_products_html = '';
      var product_show_html = '';
      //checkbox_products_set == false;/*to run all time */
      if (checkbox_products_set == false) {
        checkbox_products_set = true;


        if ($('#is_checkout_page').val() != 1) {

          // <div class="mu-text-center mu-p-2 mu-font-bold mu-w-full mu-frequently-header">YOU'LL LOVE THESE</div>

          product_show_html = `<div class="frequently-box">
                
                <div class="mu-frequently-body" id="mu-frequently-body">
                </div></div>
                `;
          $('.crm_drawer_cart_inner5').append(product_show_html);


          $.each(featured_products, function (index, value) {
            var product_show = fetchProductByHandle(value);
            if (product_show.id > 0) {
              var in_cart = cart_handles.indexOf(product_show.handle);
              product_show_html = `
              <div class="mu-border-b last:mu-border-b-0 mu-mx-2 mu-py-2 frequently-box-content  ">
              <div class="mu-flex">
                <div class="mu-rounded mu-bg-cover mu-bg-center mu-block fr-image">              
                  <img  src="${product_show.featured_image}">
                </div>
                <div class=" ">
                  <b class="mu-mb-2 mu-overflow-hidden mu-w-full mu-line-clamp">
                    <a class="product_title" href="/products/${product_show.handle}">${product_show.title}</a>
                  </b>
                  <div class="btn-100" style="padding:10px 0px;"  >
                      <span class="transcy-money">$${product_show.price / 100}</span> 
                  </div>
                  <div class="mu-items-center mu-flex-wrap">
                    <div class="variant-selector">`;
              var i = 0;
              
               product_show.options.forEach(function (option) {
                if(option.name!='Title')
                    {
                      var select = '<select id="' + product_show.handle + '_option[' + i + ']" name="' + option.name + '">';
                      var counter_print = 1;
                      option.values.forEach(function (value) {
                        if(counter_print<=max_options)
                            select += '<option value="' + value + '">' + value + '</option>';

                            counter_print++;  
                      });
                      select += '</select>';
                    i++;
                    product_show_html += select;
                  }
              });
              product_show_html += `</div>
              <div class="variant-selector">
                    <button product="${product_show.handle}"  type="button"   class="featured_products_btn 
                    `;
              if (in_cart !== -1)
                product_show_html += "in_cart";
              product_show_html += `" style="font-size: 0.8em;">
                      <span class="">`;
              if (in_cart !== -1)
                product_show_html += added_product_text;
              else
                product_show_html += add_to_cart_text;
              product_show_html += `</span>
                    </button></div>
                  </div>
                </div>
              </div>
            </div> `;
              $('#mu-frequently-body').append(product_show_html);
            }
          });

        }




        if ($('#is_checkout_page').val() == 1) {
          product_show_html = `<div class="frequently-box">               
          <div class="mu-frequently-body" id="bundle_product_list_body">
        </div></div>
        `;

          $('#bundle_product_list').html(product_show_html);


          $.each(bundle_products, function (index, value) {
            var product_show = fetchProductByHandle(value);
            if (product_show.id > 0) {
              var in_cart = cart_handles.indexOf(product_show.handle);
              product_show_html = `
            <div class="promo_1 pink_bg main_${product_show.handle} `;

              if (in_cart !== -1)
                product_show_html += "blue_bg";

              product_show_html += ` ">
            
            <div class="row align-items-center">
            
              <div class="col-1 col-md-1">
               
              
            

              <div class="checkbox-wrapper-13">
            
            <input type="checkbox" value="${product_show.handle}" id="${product_show.handle}_r"  name="checkbox_bundle"  class="featured_products_checkbox2"   ><div class="arrow_icon"><i class="fa fa-long-arrow-right" aria-hidden="true" style="position:relative;"></i></div>
            <label style="display:none;" class="checkbox style-d" for="${product_show.handle}_r"></label> 
            
          
        </div>


                  
              </div>
              <div class="col-3 col-md-2">
                  <img  src="${product_show.featured_image}" width="83">
              </div>
              <div class="col-7 col-md-9">
                <div class="row align-items-center">
                  <div class="col-10 col-md-10">
                    <div class="offers_1">Offer Ends Today</div>
                    <h5>${product_show.title}</h5>
                  </div>
                  <div class="col-2 col-md-2" style="text-align:right!important;padding-left:0px;">
                    <span class="price_cut">$${product_show.compare_at_price / 100}</span><Br/>
                    <span class="price_1">$${product_show.price / 100}</span>
                  </div>
                </div>
              </div>
            </div>
     
           <div class="white_bg ${product_show.handle}" style="display:none">
             <div class="row align-items-center">
               
               `;

              var i = 0;
              
                
               var select_option = ''; 
              product_show.options.forEach(function (option) {
                if(option.name!='Title')
                    {
                var select = '<b>' + option.name + ':</b><div class="variant-selector"><select id="' + product_show.handle + '_option[' + i + ']" name="' + option.name + '">';
                 
                var counter_print = 1;
                option.values.forEach(function (value) {
                  if(counter_print<=max_options)
                      select += '<option value="' + value + '">' + value + '</option>';

                      counter_print++;  
                });
                select += '</select> </div>';
                i++;
                select_option += select;
              }
              });

              if(select_option!='')
              {
                product_show_html += '<div class="col-12 col-md-8 col-lg-8">'+select_option+'</div>';
               
              }else{
                product_show_html += '<div class="col-12 col-md-4 col-lg-4 bundle_btn"></div>';
              } 
              
               product_show_html += `<div class="col-12 col-md-4 col-lg-4 bundle_btn">                
               <button product="${product_show.handle}" id="c_${product_show.handle}"  type="button"   class="btn bundle_products_btn 
               `;
              if (in_cart !== -1)
                product_show_html += "in_cart";
              product_show_html += `" style="font-size: 0.8em;">
                 <span class="">`;
              if (in_cart !== -1)
                product_show_html += remove_product_text;
              else
                product_show_html += add_to_cart_text;
              product_show_html += `</span>
               </button>
               </div>
             </div>
           </div>
           
          </div>
         
     </div>`;




              var j = '';
              if (in_cart !== -1)
                j += ' checked="checked" ';


              $('#bundle_product_list_body').append(product_show_html);
            }
          });


        }

        if ($('#is_checkout_page').val() != 1) {

          $.each(checkbox_products, function (index, value) {
            var product_show = fetchProductByVariant(value);
            if (product_show.id > 0) {
              var in_cart = cart_variants.indexOf(product_show.variants[0].id);
              checkbox_products_html += `<div class="add_on_product-container ">
                      <div class="add_on_product-container_main"> 
                        <div> 
                          <img src="${product_show.images[0].src}" style="width:50px; border-radius: 50%;" alt="${product_show.title}">
                        </div>                        
                        <div>
                          <div class="shipping-protection-title">${product_show.title} <span style="font-size: smaller;margin-left:5px">$${product_show.variants[0].price}</span></div>
                          <div class="shipping-protection-text">${product_show.body_html}</div>
                        </div>
                      </div>
                      <div class="add_on_product-checkbox">
                      <input type="checkbox" id="pro_${product_show.handle}" value="${product_show.variants[0].id}" `;
              if (in_cart !== -1) {
                checkbox_products_html += ' checked="" ';
              }
              checkbox_products_html += ` onchange="custom_add_remove('pro_${product_show.handle}')">
            <label for="pro_${product_show.handle}" class="toggle-switch"></label>
                      </div>
                    </div>`;
            }
          });

        }
        if (checkbox_products_html == '')
          $('.crm_drawer_cart_inner3').remove();
        else
          $('.crm_drawer_cart_inner3').html(checkbox_products_html);
      } else {



      }
      $.each(checkbox_products, function (index, variant_id) {
        var in_cart = cart_variants.indexOf(String(variant_id));
        if (in_cart == -1) {

          $('input[type="checkbox"][value="' + variant_id + '"]').prop('checked', false);
        } else {

          $('input[type="checkbox"][value="' + variant_id + '"]').prop('checked', true);
        }

      });

      $.each(featured_products, function (index, handle) {
        var in_cart = cart_handles.indexOf(handle);
        if (in_cart == -1) {
          $('button[product="' + handle + '"]').removeClass('in_cart');
          $('button[product="' + handle + '"]').find('span').html(add_to_cart_text);
        } else {
          $('button[product="' + handle + '"]').addClass('in_cart');
          $('button[product="' + handle + '"]').find('span').html(added_product_text);
        }
      });


      $.each(bundle_products, function (index, handle) {
        var in_cart = cart_handles.indexOf(handle);
        if (in_cart == -1) {
          $('button[product="' + handle + '"]').removeClass('in_cart');
          $('button[product="' + handle + '"]').find('span').html(add_to_cart_text);
        } else {
          $('button[product="' + handle + '"]').addClass('in_cart');
          $('button[product="' + handle + '"]').find('span').html(remove_product_text);
        }
      });
      
      $('#crm_overlay').hide();
      console.log('update cart compelete2');
      if (need_toggleDrawer == 1) {
        $('#crm_drawer').addClass("open"); 
        $('#crm_drawer').attr("aria-hidden", false);
        $('#crm_overlay_side').show();
        //toggleDrawer();
      }
      
      if ($('#is_checkout_page').val() == 1) 
      {
        loadCart();
        refresh_price();     
      }

    }
  });

}
function fetchProductByVariant(variantId) {
  var result = '';
  $.ajax({
    url: '/products.json',
    method: 'GET',
    async: false,
    success: function (response) {
      $.each(response.products, function (index, product) {
        $.each(product.variants, function (i, variant) {
          if (variant.id == variantId) {
            result = product;
          }
        });
      });
    },
    error: function (error) {
      console.log("Error fetching products: ", error);
    }
  });
  return result;
}
function fetchProductByHandle(productHandle) {
  var result = '';
  $.ajax({
    url: '/products/' + productHandle + '.js',
    method: 'GET',
    async: false,
    dataType: 'json',
    success: function (response) {
      result = response;
    },
    error: function (error) {
      console.log("Error fetching products: ", error);
    }
  });
  return result;
}
function crm_update_qty(variant_id, qty_action) {
  var qty = $('#qty_' + variant_id).val();
  if (qty_action == '-1')
    qty--;
  else
    qty++;
  var formData = {
    'id': variant_id,
    'quantity': qty
  };
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: formData,
    dataType: 'json',
    cache: false,
    async: false,
    success: function () {
      updateCartDrawer();
    }
  });
}

$(window).on("pageshow", function(event) {
  updateCartDrawer(0,0);
});

$(document).ready(function () {

  setTimeout(function () {
   
    $('<button/>', {
      text: 'Add to Cart',
      class: 'button btn-100 new-form-atc',
      id: 'new-form-atc2',
      click: function () {
  
         
        var variant_id = 0;
        var selectedId = $('#new-form').find('.selectedWB').attr('id');
        if (typeof selectedId !== 'undefined') {
          // If the id attribute exists, perform the replace operation
          var variant_id = selectedId.replace("id", "");
        }
        if (variant_id > 0) {
          addToCartFunction_CRM_drawer(variant_id, 1);
        }
      }
    }).insertAfter('#new-form');
  }, 1500);


});
$(document).on('click', '.featured_products_btn', function () {
  var value = $.trim($(this).find('span').text());
  if (value != added_product_text) {
    custom_add_remove_with_handle_new($(this).attr('product'), 1);
    $(this).addClass('in_cart');
    $(this).find('span').text(added_product_text);
  } else {
    custom_add_remove_with_handle_new($(this).attr('product'), 0);
    $(this).removeClass('in_cart');
    $(this).find('span').text(add_to_cart_text);
  }
});



$(document).on('click', '.bundle_products_btn', function (event) {

  event.stopPropagation();
  var value = $.trim($(this).find('span').text());
  var handle = $(this).attr('product');
  if (value != remove_product_text) {

    custom_add_remove_with_handle_new(handle, 1);
    $(this).addClass('in_cart');
    $(this).find('span').text(remove_product_text);
    $('.main_' + handle).addClass('blue_bg');

  } else {
    custom_add_remove_with_handle_new(handle, 0);
    $('#' + handle + '_r').prop('checked', false);
    $('.' + handle).hide("slow");
    $(this).removeClass('in_cart');
    $(this).find('span').text(add_to_cart_text);
    $('.main_' + handle).removeClass('blue_bg');

  }
  loadCart();
  refresh_price();

});

$(document).on('click', '.promo_1', function () {

  if (!$(this).find('.featured_products_checkbox2').is(":checked")) {
    $(this).find('.featured_products_checkbox2').prop("checked", true);
    checkbox_clicked($(this).find('.featured_products_checkbox2'));

  }

});

function checkbox_clicked(this_ref) {

  var checkbox_status = $(this_ref).is(":checked");
  if (!checkbox_status) {


    var handle = $(this_ref).val();
    $('.' + handle).hide("slow");


    var value = $.trim($('#c_' + handle).find('span').text());
   
    if (value != remove_product_text) {

     // $('#c_' + handle).addClass('in_cart');
     // $('#c_' + handle).find('span').text(remove_product_text);

    } else {
      $('#c_' + handle).removeClass('in_cart');
      $('#c_' + handle).find('span').text(add_to_cart_text);
      $('.main_' + handle).removeClass('blue_bg');

      custom_add_remove_with_handle_new(handle, 0);
      loadCart();
      refresh_price();
      

    }
    

  } else {
    var handle = $(this_ref).val();
    //$('.white_bg').hide();
    $('.' + handle).show("slow");
  }

}

$(document).on('click', '.featured_products_checkbox2', function (event) {
  event.stopPropagation();
  checkbox_clicked(this);


});
// Call updateCartDrawer function when the cart drawer is opened
$('#YourCartDrawerToggleButton').on('click', function () {
  updateCartDrawer();
});
function findVariantId(product, option1Value, option2Value) {
  var variantId = null;
  product.variants.forEach(function (variant) {
    if (variant.option1 === option1Value && (!option2Value || variant.option2 === option2Value)) {
      variantId = variant.id;
      return;
    }
  });
  return variantId;
}
function check_undefined(value) {
  if (typeof value === "undefined") {
    return '';
  } else
    return value;
}
function add_to_cart_frequently(but_ref, key, add_to_cart) {
  var variant_id = '';
  $.ajax({
    type: 'GET',
    url: '/products/' + $('#frequently-product-id' + key).val() + '.js',
    dataType: 'json',
    success: function (product) {
      variant_id = findVariantId(product, check_undefined($('#select-one' + key).val()), check_undefined($('#select-two' + key).val()))
      if (add_to_cart == 1) {
        var serializedData = '';
        serializedData += '&id=' + variant_id;
        serializedData += '&quantity=1';
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: serializedData,
          dataType: 'json',
          success: function () {
            var id = $(but_ref).attr("id");
            $("#" + id + '_exist').show();
            $("#" + id).hide();
            var cartDrawer = new theme.CartDrawer;
            cartDrawer.cartForm.buildCart();
          },
          error: function () {
          }
        });
      }
    },
    error: function (xhr, status, error) {
      console.error('Error fetching product:', status, error);
    }
  });
}
function update_frequently_products() {

  var key = $('#frequently-product-id1').val();
  if (check_id_exist(key) != "") {
    $("#" + key + '_id_exist').hide();
    $("#" + key + '_id').show();
  }
  var key = $('#frequently-product-id2').val();
  if (check_id_exist(key) != "") {
    $("#" + key + '_id_exist').hide();
    $("#" + key + '_id').show();
  }
}



function custom_add_remove_with_handle_new(handle, need_action) {
  var variant_options = [];
  // Collect all selected values for options
  $('select[id^="' + handle + '_option"]').each(function () {
    variant_options.push($(this).val());
  });

  var cart_variants = [];

  if (need_action == 0) {
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      async: false,
      success: function (cart) {
        $.each(cart.items, function (index, item) {
          cart_variants.push(item.variant_id);
        });
      }
    });
  }

  // Fetch product data (assuming this is an async function returning a promise)
  var product = fetchProductByHandle(handle);
  var variant_found = null;
  // Loop through each variant to find a match
  product.variants.forEach(function (variant) {

    if (need_action == 0) {
      var in_cart = cart_variants.indexOf(variant.id);
      if (in_cart !== -1)
        drawer_change_qty(variant.id, 0, false);

    }


    var match_count = 0;
    // Check each selected option value against the variant's options
    variant_options.forEach(function (value, index) {
      var opno = 'option' + (index + 1); // option1, option2, etc.
      if (variant[opno] === value) {
        match_count++;
      }
    });
    // If all selections match, we found our variant
    if (match_count === variant_options.length) {
      variant_found = variant;
    }
  });
  // Handle case where no variant is found
  if (!variant_found) {
    //alert("No matching variant found.");
  } else {

    if (need_action == 1) {
      //Adding Product 
      addToCartFunction_CRM_drawer(variant_found.id, 1, 1);

    }

  }
  updateCartDrawer();

}

function check_id_exist(key) {
  var result = '';
  $.ajax({
    url: '/cart.js',
    dataType: "json",
    async: false,
    success: function (cart) {
      $.each(cart.items, function (index, item) {
        if (item.handle == key)
          result = item.key;
      });
    },
    error: function (error) {
      console.error("Error:", error);
    }
  });
  return result;
}

function addToCartFunction_CRM_drawer(variant_id, qty, stop_next = 0) {
  let formData = {
    'items': [{
      'id': variant_id,
      'quantity': qty
    }]
  };
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    dataType: 'json',
    async: false,
    success: function () {

      if (stop_next == 0)
        auto_add_checkbox_products_call();


    }
  });
}




function auto_add_checkbox_products_call() {
  console.log('auto_add_checkbox_products_call');
  if (auto_add_checkbox_products == true) {
    $.getJSON('/cart.json', function (cart) {

      if (cart.item_count == 1) {
        console.log('auto_add_checkbox_products',auto_add_checkbox_products);
        if (auto_add_checkbox_products == true) {
         
          $.each(auto_add_product, function (index, variant_id) {
            console.log('adding',variant_id);
            addToCartFunction_CRM(variant_id, 1, 1);
            $('input[type="checkbox"][value="' + variant_id + '"]').prop('checked', true);
          });
          auto_add_checkbox_products = false;
        }
        updateCartDrawer(1);
      } else
        updateCartDrawer(1);

    });
  } else {
    updateCartDrawer(1);
  }



}


function drawer_change_qty(variant_id, qty, line) {
  if (line == true) {
    var formData = {
      'line': variant_id,
      'quantity': qty
    };
  } else {
    var formData = {
      'id': variant_id,
      'quantity': qty
    };
  }
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: formData,
    dataType: 'json',
    cache: false,
    async: false,
    success: function () {

    }
  });
}

$(document).ready(function(){
  //$("#enable_vip_btn").data('value', '{{ vip_redirect }}');
 // $("#nreDirectUrl").val('{{ vip_redirect }}');

  $('body').on('click', '.user_add_to_cart', function(e){ 
    e.preventDefault(); 
      var radios = document.getElementsByName( 'user type' );
      if(radios.length<2)
      {
        radios = document.getElementsByName( 'User type' );
      }
      $('#crm_overlay').show();
      console.log(e.currentTarget.dataset.addtocart);
      for( i = 0; i < radios.length; i++ ) {
       // console.log('radio i name' ,i, radios[i].name);
       // console.log('radio i ' ,i, radios[i].value);
        if( radios[i].value==e.currentTarget.dataset.addtocart ) {
          //console.log('radio click');
          
          if($("#addToCart").is(":disabled")==false){
             console.log('here');
             radios[i].click();
             
                                     
            if(e.currentTarget.dataset.addtocart=='VIP Price'){
              $('#addToCart').trigger('click');      
              //window.location.href = "{{vip_redirect}}";
            }else{   
              console.log('here else');
              $.ajax({
                url: '/cart.js',
                dataType: "json",
                cache: false,
                success: function(cart) {
                  Shopify.queue = [];
                  $.each(cart.items, function(index, item) {              
                    if($.inArray('VIP Price', item.variant_options) !== -1){
                      Shopify.queue.push({
                        variantId: item.variant_id,
                      });
                    }
                  });
                 
                  Shopify.moveAlong = function() {
                      // If we still have requests in the queue, let's process the next one.                      
                      if (Shopify.queue.length) {
                        var request = Shopify.queue.shift();
                          var data = 'id='+ request.variantId + '&quantity=0'
                          $.ajax({
                            type: 'POST',
                            url: '/cart/change.js',
                            dataType: 'json',
                            data: data,
                            success: function(res){
                                Shopify.moveAlong();                          
                            },
                          });                  
                      }else if(Shopify.queue.length==0){
                        auto_add_checkbox_products = false;
                        $('#addToCart').trigger('click');      
                        setTimeout(function () {
                          window.location.href = "/pages/checkout-3";
                        }, 800);
                      }
                  };
                  Shopify.moveAlong();                    
                }
              });
              
            }
            return false; // breaks
          }else{
            alert('This variant out of stock.');
          }          
        }
      }
  });
  $('body').on('click', '#atc-button-new', function(e){   
      


        e.preventDefault(); 
   
        var variant_id = $(".product-variant-id").val(); 
        var quantity = $(".quantity__input").val(); 
        if(quantity==null)
        {
          quantity=1;
        }
      
        addToCartFunction_CRM_drawer(variant_id,quantity,0);
       

       
  }); 
});